(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9135],{

/***/ 13337:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[category]/[subcategory]/[...slug]",
      function () {
        return __webpack_require__(87695);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ DocsTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react/cjs/react.production.min.js
var react_production_min = __webpack_require__(72408);
// EXTERNAL MODULE: ./utils/normalize-string.ts
var normalize_string = __webpack_require__(35182);
;// CONCATENATED MODULE: ./components/docs/page/template/table-of-contents.tsx
// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck




function TableOfContents(param) {
    let { content  } = param;
    const [activeId, setActiveId] = (0,react_production_min.useState)("");
    const { toKebabCase  } = normalize_string/* normalizeString */.U;
    const callback = (entries)=>{
        const intersections = entries.reduce((acc, entry)=>{
            // Add intersecting entries to array
            return entry.isIntersecting ? acc.concat(entry) : acc;
        }, []);
        if (intersections[0]) {
            var ref, ref1;
            // Get ID from first intersection entry
            setActiveId((ref = intersections[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.target) === null || ref1 === void 0 ? void 0 : ref1.id);
        }
    };
    const headingsData = content === null || content === void 0 ? void 0 : content.reduce((acc, cur)=>{
        if (cur._type === "block" && [
            "h2",
            "h3"
        ].includes(cur.style)) {
            var ref;
            const text = (ref = cur.children[0]) === null || ref === void 0 ? void 0 : ref.text;
            if (text) {
                acc.push({
                    id: toKebabCase(text),
                    element: cur.style,
                    text
                });
            }
        }
        return acc;
    }, []);
    (0,react_production_min.useEffect)(()=>{
        let observer;
        if ("IntersectionObserver" in window) {
            observer = new IntersectionObserver(callback);
            headingsData.forEach((item)=>{
                const heading = document.getElementById(item.id);
                observer.observe(heading);
            });
        }
        return ()=>{
            observer.disconnect();
        };
    }, [
        headingsData
    ]);
    if (!headingsData.length) {
        // No headings for ToC
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        as: "nav",
        "aria-label": "Table of Contents",
        bg: "var(--bodyBg)",
        pos: "sticky",
        top: "105px",
        display: {
            base: "none",
            xl: "block"
        },
        w: "280px",
        h: "calc(100vh - 120px)",
        pb: 12,
        pl: 8,
        overflow: "auto",
        flexShrink: 0,
        sx: {
            msOverflowStyle: "none" /* IE and Edge */ ,
            scrollbarWidth: "none" /* Firefox */ ,
            "&::-webkit-scrollbar": {
                display: "none" /* Chrome, Safari and Opera */ 
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* UnorderedList */.QI, {
            children: headingsData.map((param, index)=>{
                let { id , element , text  } = param;
                const isActive = id === activeId;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                    listStyleType: "none",
                    borderLeft: "1px solid",
                    borderColor: isActive ? "var(--primaryBlue)" : "var(--borderColor)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        as: "a",
                        href: "#".concat(id),
                        textStyle: "xs-medium",
                        color: isActive ? "var(--primaryTextColor)" : "var(--secondaryTextColor)",
                        display: "block",
                        px: 4,
                        py: 1.5,
                        ml: element !== "h2" ? 4 : 0,
                        transition: "color 0.2s",
                        _hover: {
                            color: "var(--primaryTextColor)"
                        },
                        onClick: (event)=>{
                            event.preventDefault();
                            if (true) {
                                window.history.pushState(null, "", "#".concat(id));
                                window.scroll({
                                    top: document.getElementById(id).offsetTop - 80,
                                    behavior: "smooth"
                                });
                            }
                        },
                        children: text
                    })
                }, "".concat(id, "-").concat(index));
            })
        })
    });
}

// EXTERNAL MODULE: ./components/sanity/sane-block.tsx + 14 modules
var sane_block = __webpack_require__(51061);
// EXTERNAL MODULE: ./components/docs/page/page-container.tsx
var page_container = __webpack_require__(29856);
// EXTERNAL MODULE: ./pages/index.tsx + 31 modules
var pages = __webpack_require__(16263);
;// CONCATENATED MODULE: ./components/docs/page/template/template.tsx







function DocsTemplate(param) {
    let { content  } = param;
    (0,react_production_min.useEffect)(()=>{
        pages.analytics.track("Docs_Page_".concat(content.title, " Viewed"), {
            surface: "Docs",
            location: "Page"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(page_container/* PageContainer */._, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            py: 12,
            mx: "auto",
            justify: "center",
            color: "var(--primaryTextColor)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    px: {
                        base: 6,
                        lg: 10
                    },
                    sx: {
                        maxW: "full",
                        // Chakra's `xl` breakpoint; table of contents appears here
                        "@media screen and (min-width: 1280px)": {
                            maxW: "container.sm"
                        },
                        "@media screen and (min-width: 1400px)": {
                            maxW: "container.md"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            as: "h1",
                            size: "h4",
                            mb: 3,
                            color: "var(--primaryTextColor)",
                            children: content.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            as: "h3",
                            textStyle: "md-normal",
                            color: "var(--secondaryTextColor)",
                            mb: 6,
                            children: content.subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_block/* SaneBlockChakra */.C, {
                            blocks: content.body
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                    content: content.body
                })
            ]
        })
    });
}


/***/ }),

/***/ 87585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pk": function() { return /* binding */ tutorialQuery; },
/* harmony export */   "Tc": function() { return /* binding */ docBySlugQuery; },
/* harmony export */   "Zk": function() { return /* binding */ blogQuery; }
/* harmony export */ });
/* unused harmony exports blogIndexQueryProduction, blogIndexQueryPreview, guidesIndexQueryProduction, guidesIndexQueryPreview, authorQuery, investorQuery, docQuery, pageQuery, siteSettingsQuery, blogSlugsQueryProduction, blogSlugsQueryPreview, blogBySlugQuery, tutorialSlugsQueryProduction, tutorialSlugsQueryPreview, tutorialBySlugQuery, marketingLPSlugsQuery, marketingLPBySlugQuery, docSlugsQuery, navigationQuery */
const blogFields = '\n  _id,\n  name,\n  title,\n  date,\n  excerpt,\n  coverImage,\n  category,\n  mdx,\n  live,\n  "slug": slug.current,\n  "author": author->{name, picture},\n  seo,\n  featured\n';
const tutorialFields = '\n_id,\nname,\ntitle,\nexcerpt,\ncoverImage,\ncategory,\nlive,\n"slug": slug.current,\n"author": author->{name, picture},\ntime,\nmarkdown,\nbody[] {\n  ...,\n  markDefs[]{\n    ...,\n    _type == "internalLink" => {\n      "slug": @.reference->slug\n    }\n  },\n  body[] {\n    ...,\n    markDefs[]{\n      ...,\n      _type == "internalLink" => {\n        "slug": @.reference->slug\n      }\n    }\n  },\n},\nseo\n';
const docFields = '\n  _id,\n  seo,\n  title,\n  subtitle,\n  body[] {\n    ...,\n    markDefs[]{\n      ...,\n      _type == "internalLink" => {\n        "slug": @.reference->slug\n      }\n    },\n    body[] {\n      ...,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      }\n    },\n  },\n  "slug": slug.current\n';
const authorFields = "\n  _id,\n  name,\n  picture,\n  role,\n  socials,\n  teammate\n";
const investorFields = "\n  _id,\n  name,\n  picture,\n  role,\n  url\n";
const pageFields = '\n  _id,\n  seo,\n  pageText,\n  pageCode,\n  pageImage,\n  pageJSON,\n  body[]{\n    ...,\n    richText[]{\n      ...,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      }\n    }\n  },\n  "slug": slug.current,\n';
const blogIndexQueryProduction = "\n*[_type == \"blog\" && live == true && !(_id in path('drafts.**'))] | order(date desc, _updatedAt desc) {\n  ".concat(blogFields, "\n}");
const blogIndexQueryPreview = "\n*[_type == \"blog\" && !(_id in path('drafts.**'))]  | order(date desc, _updatedAt desc) {\n  ".concat(blogFields, "\n}");
const guidesIndexQueryProduction = '\n*[(_type == \'tutorial\' || _type == "blog") && live == true && (category == "Guide" || category == "Tutorial") && !(_id in path(\'drafts.**\'))] | order(date desc, _updatedAt desc) {\n  '.concat(blogFields, "\n}");
const guidesIndexQueryPreview = '\n*[(_type == \'tutorial\' || _type == "blog") && (category == "Guide" || category == "Tutorial") && !(_id in path(\'drafts.**\'))] | order(date desc, _updatedAt desc) {\n  '.concat(blogFields, "\n}");
const authorQuery = '\n*[_type == "author"] | order(order asc) {\n  '.concat(authorFields, "\n}");
const investorQuery = '\n*[_type == "investor"] | order(order asc) {\n  '.concat(investorFields, "\n}");
const docQuery = '\n*[_type == "doc"] {\n    _id,\n  title,\n  "slug": slug.current\n}';
const blogQuery = '\n{\n  "blog": *[_type == "blog" && slug.current == $slug] | order(_updatedAt desc)[0]{\n    "body": body[]{\n      ...,\n      authors[]->,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      },\n      body[] {\n        ...,\n        markDefs[]{\n          ...,\n          _type == "internalLink" => {\n            "slug": @.reference->slug\n          }\n        }\n      }\n},\n    '.concat(blogFields, '\n  },\n  "moreBlogs": *[_type == "blog" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    ').concat(blogFields, "\n  }\n}");
const tutorialQuery = '\n{\n  "tutorial": *[_type == "tutorial" && slug.current == $slug] | order(_updatedAt desc)[0]{\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    '.concat(tutorialFields, '\n  },\n  "moreTutorials": *[_type == "tutorial" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    ').concat(tutorialFields, "\n  }\n}");
const pageQuery = '\n{\n  "page": *[_type == "page" && slug.current == $slug] | order(_updatedAt desc)[0] {\n    content,\n    '.concat(pageFields, "\n  },\n}");
const siteSettingsQuery = '\n*[_type == "siteSettings"] | order(order asc)';
const blogSlugsQueryProduction = '\n*[_type == "blog" && live == true && defined(slug.current)][].slug.current\n';
const blogSlugsQueryPreview = '\n*[_type == "blog" && defined(slug.current)][].slug.current\n';
const blogBySlugQuery = '\n*[_type == "blog" && slug.current == $slug][0] {\n  '.concat(blogFields, "\n}\n");
const tutorialSlugsQueryProduction = '\n*[_type == "tutorial" && live == true && defined(slug.current)][].slug.current\n';
const tutorialSlugsQueryPreview = '\n*[_type == "tutorial" && defined(slug.current)][].slug.current\n';
const tutorialBySlugQuery = '\n*[_type == "tutorial" && slug.current == $slug][0] {\n  '.concat(tutorialFields, "\n}\n");
const marketingLPSlugsQuery = '\n*[_type == "marketing-lp" && defined(slug.current)][].slug.current\n';
const marketingLPBySlugQuery = '\n{\n  "page": *[_type == "marketing-lp" && slug.current == $slug][0] {\n    '.concat(pageFields, "\n  }\n}\n");
const docSlugsQuery = '\n*[_type == "doc" && defined(slug.current)][].slug.current\n';
const docBySlugQuery = '\n*[_type == "doc" && slug.current == $slug] | order(_updatedAt desc)[0] {\n  '.concat(docFields, "\n}\n");
const navigationQuery = '\n*[navId.current match "docs-*"] | order(order asc) {\n  name,\n "navId": navId.current,\n "categories": linkCategories[]{\n   "categoryId": categoryId.current,\n   categoryName,\n   links[] {\n     _key,\n     title,\n     "slug": internalLink->slug.current,\n     "url": externalLink.href,\n     "childLinks": links[]{\n       _key, \n       title, \n       "slug": internalLink->slug.current, \n       "url": externalLink.href\n     }\n   }\n }\n}\n';


/***/ }),

/***/ 87695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ DocsPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87585);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53822);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8253);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32596);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6903);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62281);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36651);








var __N_SSG = true;
function DocsPage(param) {
    let { data , preview , navigation  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useRouteScroll */ .t)();
    const slug = data === null || data === void 0 ? void 0 : data.slug;
    const { data: docData  } = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_4__/* .usePreviewSubscription */ .$r)(_lib_queries__WEBPACK_IMPORTED_MODULE_3__/* .docBySlugQuery */ .Tc, {
        params: {
            slug
        },
        initialData: data,
        enabled: preview && slug
    });
    if (!data || !router.isFallback && !data.slug) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
            statusCode: 404
        });
    }
    return router.isFallback ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: "Loading..."
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        minH: "100vh",
        bg: "var(--bodyBg)",
        color: "var(--primaryTextColor)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .DocsSidenav */ .x, {
                navigation: navigation
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__/* .DocsHeader */ .U, {
                navigation: navigation
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_9__/* .DocsTemplate */ .g, {
                content: docData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_10__/* .DocsFooter */ .E, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6241,9385,2868,659,1061,617,9774,2888,179], function() { return __webpack_exec__(13337); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);